module.exports = __webpack_public_path__ + "img/new3.96e66362.png";